<template>
  <el-container style="background-color: #f5f7fe">
    <el-header>
      <el-row style="box-shadow: rgb(243 243 243) 0px 0px 12px 3px">
        <el-col :span="9">
          <el-row>
            <el-col :span="2">
              <img class="img-one" src="@/assets/excavationsImg/logo.svg" alt />
            </el-col>
            <el-col :span="19" class="text-4">构件管理云平台</el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-header>
    <div class="flexColumn" style="height: 85%; width: 100%; margin: auto">
      <div style="text-align: right; width: 60%">
        已有账号？<a
          href="javascript:void"
          style="color: #035dff"
          @click="$router.push('/')"
          >立即登录</a
        >
      </div>
      <el-card
        shadow="always"
        style="width: 60%; margin: auto; height: 85%"
        :body-style="{ padding: '20px', height: '100%' }"
      >
        <h1 style="text-align: center; font-weight: 700; letter-spacing: 6px">
          {{ $route.meta.title }}
        </h1>
        <el-steps
          :active="active"
          style="width: 40%; margin: 30px auto 0"
          align-center
        >
          <el-step title="帐号验证" description=""></el-step>
          <el-step title="重置密码" description=""></el-step>
          <el-step title="完成" description=""></el-step>
        </el-steps>
        <router-view
          v-if="viewShow"
          class="animate__animated"
          :class="is ? 'animate__fadeInRightBig' : 'animate__fadeInLeftBig'"
          ref="view"
        ></router-view>
        <div style="height: 40px; margin-top: 10px" class="flex">
          <el-radio-group
            @change="radioChange"
            v-model="radio"
            style="margin: auto"
          >
            <el-radio disabled label="accountValidation">{{ null }}</el-radio>
            <el-radio disabled label="resetPasswords">{{ null }}</el-radio>
            <el-radio disabled label="resetResult">{{ null }}</el-radio>
          </el-radio-group>
        </div>
      </el-card>
      <div class="flexColumn" style="letter-spacing: 2px">
        <div>EaBIM论坛 版权所有©2016-2022| 沪ICP备16037428号-6</div>
        <div class="flex">
          <div>联系我们：wjc@eabim.cn</div>
          <div style="margin-left: 20px">
            技术支持：上海益埃毕建筑科技有限公司
          </div>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import personal from "../my/personal";
import { outLogin } from "@/setAxios";
export default {
  name: "retrievePassword",
  data() {
    return {
      viewShow: true,
      radio: "accountValidation",
      is: true,
      active: 1,
    };
  },
  provide() {
    return {
      updateRadio: this.updateRadio,
    };
  },
  created() {
    this.radio = this.$route.name;
  },
  //利用计算属性
  computed: {},
  //监听执行
  watch: {
    radio(a, b) {
      if (a == "accountValidation") {
        this.is = false;
      } else if (a == "resetPasswords" && b == "resetResult") {
        this.is = false;
      } else {
        this.is = true;
      }
      switch (a) {
        case "accountValidation":
          this.active = 1;
          break;
        case "resetPasswords":
          this.active = 2;
          break;
        default:
          this.active = 3;
          break;
      }
    },
    $route: {
      handler(a, b) {
        if (a.name == "accountValidation") {
          this.is = false;
        } else if (a == "resetPasswords" && b == "resetResult") {
          this.is = false;
        } else {
          this.is = true;
        }
        switch (a.name) {
          case "accountValidation":
            this.active = 1;
            break;
          case "resetPasswords":
            this.active = 2;
            break;
          default:
            this.active = 3;
            break;
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    updateRadio(v) {
      this.radio = v;
      this.$forceUpdate();
    },
    radioChange(v) {
      this.$forceUpdate();
      this.$router.push(v);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.is-checked .el-radio__inner {
  background-color: #409eff !important;
}
/deep/.el-radio__input {
  position: initial !important;
}
/deep/.el-card__body {
  height: 100%;
  box-sizing: border-box;
}
/deep/.el-radio {
  margin-right: 0px;
  margin-left: 30px;
}
/deep/.el-radio__inner::after {
  background-color: transparent;
}
.el-container {
  width: 100%;
  height: 100%;
  box-shadow: none;
  .el-main {
    padding: 0;
  }
}
.container {
  padding: 20px;
  width: 50%;
  height: 80%;
  margin: auto auto;
  background-color: red;
}
.el-menu-item:hover {
  background-color: #e0efff;
}
.is-active {
  background-color: white;
  border-radius: 50px 0 0 50px;
  font-weight: 700;
}
.el-menu li {
  border-radius: 50px 0 0 50px;
}
.el-header {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  line-height: 60px;
  padding: 0px;
  .el-col-1 {
    margin-left: 30px;
    img {
      height: 60px;
    }
  }
  .text-4 {
    font-weight: 700;
    font-style: normal;
    color: #000000;
    font-size: 20px;
    text-align: left;
  }
}

.el-aside {
  background-color: #bfcbd9;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.view {
  background-color: #f5f7fe;
  width: auto;
  padding: 20px;
  height: calc(100vh - 60px);
}
/deep/.el-menu {
  background-color: transparent;
}

.right-menu {
  &:focus {
    outline: none;
  }

  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    height: 100%;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  .avatar-container {
    margin-right: 30px;
    .avatar-wrapper {
      position: relative;
      height: 45px;
      .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}

// 新增
.img-one {
  height: 30px;
  border-radius: 3px;
}

.box-two {
  font-weight: 700;
  float: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 20px;
}
.float-r {
  float: right !important;
}
</style>

